module.exports = __webpack_public_path__ + "static/integration/custom/canvas.efa431314734a7b57eb41c1afa7285a1.css";